export default "__VITE_ASSET__281d386e__"